<template>
    <div class="p-mobile-input">
        <div class="content" :style="classStyle">
            <div :style="labelStyle" v-if="$slots.label">
                <slot name="label"></slot>
            </div>
            <div
                class="input-wrp"
                :class="{ error: hasErrors, showBorders: showBorder }"
                :key="inputKey"
                :style="containerStyle"
            >
                <input
                    v-model="inputValue"
                    :key="inputKey"
                    ref="newInput"
                    class="p-input"
                     inputmode="decimal"
                    :maxlength="formatMaxlength"
                    :placeholder="placeholder"
                      :style="inputStyle"
                    style="
                        padding: 0 !important;
                        border: none !important;
                        outline: none !important;
                        -webkit-appearance: none !important;
                        -moz-appearance: none !important;
                        appearance: none !important;
                    "
                    @input="inputHandler"
                    @focus="hasErrors = false"
                    @blur="handleBlur"
                    @compositionstart="isComposing = true"
                    @compositionend="onCompositionEnd"
                />
                <div :style="prefixStyle" v-if="$slots.prefix">
                    <slot name="prefix"></slot>
                </div>
            </div>
        </div>
        <div :style="warningStyle" v-if="hasErrors">
            <slot name="error"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "p-mobile-input", //组件名
    data() {
        return {
            inputValue: "",
            selectionStart: -1,
            selectionEnd: -1,
            oldValue: "",
            type: null,
            hasErrors: false,
            inputKey: "inputKey",
            isComposing: false,
        };
    },
    watch: {
        defaultValue: {
            handler(newVal) {
                if (this.inputValue) {
                    return;
                }
                if (newVal) {
                    this.inputValue = newVal;
                    this.$nextTick(() => {
                        this.inputHandler(null, true);
                    });
                }
            },
            immediate: true,
        },
        inputValue: {
            handler(newVal) {
                this.$emit("input", newVal.replace(/^\+1\s*/, "").replace(/\D/g, ""));
            },
            immediate: true,
        },
    },
    props: {
        maxlength: {
            type: Number,
            default: 10,
        },
        classStyle: {
            type: Object,
            default: () => {
            },
        },
        placeholder: {
            type: String,
            default: "",
        },
        labelStyle: {
            type: Object,
            default: () => {
            },
        },
        prefixStyle: {
            type: Object,
            default: () => {
            },
        },
        defaultValue: {
            type: String,
            default: "",
        },
        warningStyle: {
            type: Object,
            default: () => {
            },
        },
        containerStyle: {
            type: Object,
            default: () => {
            },
        },
        showBorder: {
            type: Boolean,
            default: false,
        },
        inputStyle: {
            type: Object,
            default: () => {
            },
        },
    },
    computed: {
        formatMaxlength() {
            return this.maxlength + 7;
        },
    },
    methods: {
        formatInput(newValue) {
            let formatValue = "";
            if (newValue > 0) {
                let formattedNumber = "";
                if (newValue.length <= 3) {
                    formattedNumber = `(${newValue}`;
                } else if (newValue.length <= 6) {
                    formattedNumber = `(${newValue.slice(0, 3)}) ${newValue.slice(3)}`;
                } else {
                    formattedNumber = `(${newValue.slice(0, 3)}) ${newValue.slice(
                        3,
                        6
                    )}-${newValue.slice(6, 10)}`;
                }

                // 如果当前值不包含前缀，添加前缀
                if (!newValue.startsWith("+1")) {
                    formatValue = `+1 ${formattedNumber}`;
                } else {
                    // 如果已经有前缀，只更新数字部分
                    const prefix = "+1 ";
                    formatValue = prefix + formattedNumber;
                }
            } else {
                formatValue = "";
            }
            return formatValue;
        },
        onCompositionEnd(e) {
            this.isComposing = false;
            this.inputHandler(e);
        },
        inputHandler(e, first) {
            if (this.isComposing) return;
            let newValue = first
                ? this.defaultValue
                : this.inputValue.replace(/^\+1\s*/, "").replace(/\D/g, "");

            if (!newValue.length) {
                this.$refs.newInput.value = "";
                this.inputValue = "";
                this.oldValue = "";
                this.$emit("input", "");
                return;
            }

            const oldValueFormat = this.oldValue
                .replace(/^\+1\s*/, "")
                .replace(/\D/g, "");
            this.type =
                oldValueFormat == newValue
                    ? "char"
                    : oldValueFormat &&
                    newValue &&
                    oldValueFormat.length - newValue.length == 1
                        ? "delete"
                        : "add";
            this.oldValue = this.inputValue;
            this.selectionStart = this.$refs.newInput.selectionStart;
            this.selectionEnd = this.$refs.newInput.selectionEnd;
            console.log("type", this.type, this.inputValue, oldValueFormat, newValue);
            this.$nextTick(() => {
                if (this.type == "delete") {
                    let formatValue = this.formatInput(newValue);
                    this.$refs.newInput.value = formatValue;
                    this.$refs.newInput.setSelectionRange(
                        this.selectionStart,
                        this.selectionEnd
                    );
                } else if (this.type == "add") {
                    let formatValue = this.formatInput(newValue);
                    this.$refs.newInput.value = formatValue;
                    const index = {
                        1: 5,
                        4: 10,
                        7: 15,
                    };
                    const newValueForIndex = {
                        1: 1,
                        2: 6,
                        3: 7,
                        4: 8,
                        5: 11,
                        6: 12,
                        7: 13,
                        8: 15,
                        9: 16,
                        10: 17,
                    };
                    const selection = () => {
                        if (newValueForIndex[newValue.length] == this.selectionStart) {
                            return [1, 4, 7].includes(newValue.length)
                                ? index[newValue.length]
                                : this.selectionStart;
                        } else {
                            return this.selectionStart;
                        }
                    };
                    this.$refs.newInput.setSelectionRange(selection(), selection());
                } else {
                    const func = {
                        7: () => {
                            const value = this.formatInput(
                                newValue.slice(0, 2) + newValue.slice(3)
                            );
                            this.$refs.newInput.value = value;
                            this.$refs.newInput.setSelectionRange(7, 7);
                        },
                        8: () => {
                            const value = this.formatInput(
                                newValue.slice(0, 2) + newValue.slice(3)
                            );
                            this.$refs.newInput.value = value;
                            this.$refs.newInput.setSelectionRange(7, 7);
                        },
                        12: () => {
                            const value = this.formatInput(
                                newValue.slice(0, 5) + newValue.slice(6)
                            );
                            this.$refs.newInput.value = value;
                            this.$refs.newInput.setSelectionRange(12, 12);
                        },
                    };
                    if ([7, 8, 12].includes(this.selectionStart)) {
                        func[this.selectionStart]();
                    } else {
                        let formatValue = this.formatInput(newValue);
                        this.$refs.newInput.value = formatValue;
                    }
                }
            });
        },
        handleBlur() {
            const phoneNumber = this.inputValue
                .replace(/^\+1\s*/, "")
                .replace(/\D/g, "");
            console.log("blur");
            this.hasErrors = phoneNumber.length == 0;
        },
    },
};
</script>
<style scoped lang="scss">
.p-mobile-input {
    text-align: left;
    width: 100%;

    .content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;

        .input-wrp {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 20px;
            box-sizing: border-box;

            &.error {
                border-color: red;
            }

            .p-input {
                width: 100%;
                height: 80%;
                font-size: 24px;
                &:focus {
                    outline: none;
                    border: none;
                    background: transparent;
                }
            }
        }
    }
}

.error-message {
    color: red;
    font-size: 12px;
}

input::placeholder {
    color: #b3b3b3;
}

.showBorders {
    border: 1px solid #dadbde;
    padding: 20px;
}

</style>
